import { GetAllNews } from './components/getAllNews.js';

let news = new GetAllNews();

const blockNews = document.getElementById("home_slider")

if( blockNews ) {
   news.callApi("news");
}

const blockAct = document.getElementById("actuality")

if( blockAct ) {
    news.callApi("actuality");
}